import React from 'react'

type TableSkeletonProps = {
  columns: number
  rows?: number
  rowHeight?: number | string // px or rem
  withHeader?: boolean
  className?: string
}

export default function TableSkeleton({
  columns,
  rows = 8,
  rowHeight = 44,
  withHeader = true,
  className = '',
}: TableSkeletonProps) {
  const gridTemplateColumns = `repeat(${columns}, minmax(0, 1fr))`
  const resolvedHeight = typeof rowHeight === 'number' ? `${rowHeight}px` : rowHeight

  return (
    <div className={`overflow-hidden w-full h-full animate-pulse ${className}`}>
      <div className="w-full h-full">
        <div className="flex flex-col gap-[4px] w-full h-full overflow-hidden pr-1 px-2">
          {Array.from({ length: rows }).map((_, r) => (
            <div
              key={`row-${r}`}
              className={`grid items-center gap-1 flex-none ${withHeader && r == 0 ? 'border-b border-base-300 pb-2 mb-2' : ''}`}
              style={{
                gridTemplateColumns,
                height: resolvedHeight,
              }}
            >
              {Array.from({ length: columns }).map((__, c) => (
                <div key={`cell-${r}-${c}`} className="w-full h-full flex items-center">
                  <div
                    className="w-full bg-base-300/70"
                    style={{
                      height: `calc(${resolvedHeight} - 8px)`, // subtract a little to keep padding look
                    }}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
